import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'

import * as ActionTypes from '../actions'

function esdpMap (state = null, action) {
  if (action.type === ActionTypes.MAP_LOADED) {
    state = action.mapData.data
  }

  return state
}

function appMeta (state = {summaryTabEnabled: false, summaryEmailSuccess: null}, action) {
  switch (action.type) {
    case ActionTypes.SUMMARY_TAB_ENABLED:
      return {
        ...state,
        summaryTabEnabled: action.enabled
      }
    case ActionTypes.SUMMARY_EMAIL_STATUS:
      return {
        ...state,
        summaryEmailSuccess: action.status
      }
    default:
      return state
  }
}

function serviceInfo (state = {consumerServiceUrl: 'http://consumerservice.local', contentServiceUrl: 'http://contentservice.local', isMocked: true}, action) {
  switch (action.type) {
    case ActionTypes.JWT_REFRESH:
      return {
        ...state,
        token: action.token
      }
    default:
      return state
  }
}

function prescriptionInfo (state = null, action) {
  return state
}

function navigationInfo (state = [], action) {
  switch (action.type) {
    case ActionTypes.MAP_LOADED:
      return action.mapData.navigationInfo.map((info) => {
        info.visited = false
        return info
      })

    case ActionTypes.SET_VISITED_NAV: {
      return state.map((info) => {
        if (info.id === action.id) {
          info.visited = true
        }
        return info
      })
    }

    default:
      return state
  }
}

function responseState (state = {'sequenceNumber': 0, 'responses': {}}, action) {
  // in this case, the state is currently the same for all 3 types
  const newState = {
    ...state,
    responses: action && action.responses
  }

  switch (action.type) {
    case ActionTypes.LIKERT_RESPONSE:
      return newState
    case ActionTypes.OPINION_RESPONSE:
      return newState
    case ActionTypes.QUIZ_RESPONSE:
      return newState
    default:
      return state
  }
}

const rootReducer = combineReducers({
  esdpMap,
  appMeta,
  routing,
  serviceInfo,
  responseState,
  prescriptionInfo,
  navigationInfo
})

export default rootReducer



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/reducers/index.js